import { queryOptions, useQuery, useQueryClient } from '@tanstack/react-query';
import API from '@/api';
import { queryKeys } from '@/api/utils/queryKeys';
import { EXTENDED_STALE_TIME } from '@/constants/constants';
import POLLING_INTERVALS from '@/constants/pollingIntervals';

const pendingTransactionPollingQueryOptions = (queryClient: ReturnType<typeof useQueryClient>) =>
  queryOptions({
    queryKey: queryKeys.pendingTransaction,
    queryFn: async () => {
      const response = await API.paymentProvider.getPendingTransaction();

      if (!response.pendingTransaction) {
        await Promise.all([
          queryClient.invalidateQueries({ queryKey: queryKeys.debtConsolidationFeatures }),
          queryClient.invalidateQueries({ queryKey: queryKeys.creditFeatures }),
          queryClient.invalidateQueries({ queryKey: queryKeys.loanFeatures }),
          queryClient.invalidateQueries({ queryKey: queryKeys.me }),
          queryClient.invalidateQueries({ queryKey: queryKeys.overdueInfo }),
          queryClient.invalidateQueries({ queryKey: queryKeys.SE.paymentProtectionInsurance }),
          queryClient.invalidateQueries({ queryKey: queryKeys.userPaymentProtectionInsurance }),
          queryClient.invalidateQueries({ queryKey: queryKeys.transactions }),
        ]);
      }

      return response;
    },
    refetchInterval: query =>
      query.state.data?.pendingTransaction && !query.state.data.delayed ? POLLING_INTERVALS.MEDIUM : false,
    staleTime: EXTENDED_STALE_TIME,
    refetchOnWindowFocus: false,
  });

const usePendingTransactionPolling = () => {
  const queryClient = useQueryClient();
  return useQuery(pendingTransactionPollingQueryOptions(queryClient));
};

export default usePendingTransactionPolling;
